
import { Building2, Mail, Phone, FileText, Shield } from "lucide-react";
import { Separator } from "./ui/separator";
import { Link } from "react-router-dom";
import { QuickLinks } from "./footer/QuickLinks";

export const Footer = () => {
  const popularServices = [
    { name: "Plumbing", path: "/best-plumbers-okc" },
    { name: "Electrical", path: "/best-electricians-okc" },
    { name: "HVAC", path: "/best-hvac-contractors-okc" },
    { name: "Roofing", path: "/best-roofers-okc" }
  ];

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer className="bg-[#174996] text-white/90 mt-20">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          {/* Company Info */}
          <div className="md:col-span-3 space-y-4">
            <div className="flex items-center space-x-2">
              <Building2 className="h-6 w-6 text-white" />
              <span className="text-xl font-bold">Home Pros OKC</span>
            </div>
            <p className="text-sm text-white/80 max-w-md">
              Connecting Oklahoma City homeowners with trusted, vetted service professionals for peace of mind on every project.
            </p>
          </div>
          
          {/* Quick Links */}
          <QuickLinks />
          
          {/* Popular Services */}
          <div className="md:col-span-3">
            <h3 className="font-semibold mb-4 text-white">Popular Services</h3>
            <ul className="space-y-3 text-sm text-white/80">
              {popularServices.map((service) => (
                <li key={service.name}>
                  <Link 
                    to={service.path}
                    className="hover:text-white transition-colors"
                    onClick={handleClick}
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Contact Info */}
          <div className="md:col-span-3">
            <h3 className="font-semibold mb-4 text-white">Contact Us</h3>
            <ul className="space-y-4 text-sm text-white/80">
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 min-h-[20px] min-w-[20px] flex-shrink-0" />
                <a 
                  href="tel:+14059726779" 
                  className="hover:text-white transition-colors"
                >
                  (405) 972-6779
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 min-h-[20px] min-w-[20px] flex-shrink-0" />
                <a 
                  href="mailto:support@homeprosokc.com"
                  className="hover:text-white transition-colors break-all"
                >
                  support@homeprosokc.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <Separator className="my-8 bg-white/20" />
        
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-white/80 gap-4">
          <p>&copy; {new Date().getFullYear()} Home Pros OKC. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/terms-of-service" className="hover:text-white transition-colors flex items-center gap-2" onClick={handleClick}>
              <FileText className="h-4 w-4" />
              Terms of Service
            </Link>
            <Link to="/privacy-policy" className="hover:text-white transition-colors flex items-center gap-2" onClick={handleClick}>
              <Shield className="h-4 w-4" />
              Privacy Policy
            </Link>
          </div>
        </div>
        
        <div className="text-center mt-4 pt-4 border-t border-white/10">
          <p className="text-xs text-white/60">
            Built and Powered by{" "}
            <a 
              href="https://www.evolveagencyok.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors underline decoration-white/30 hover:decoration-white"
            >
              Evolve Agency
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
